import * as React from 'react';
export const cartaSvg = React.forwardRef(function cartaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M5 11v9.592h22V11H5Zm21.416 9.008H5.585v-8.423h20.83v8.423ZM8.181 16.036c0-1.085.911-1.722 1.729-1.722.585 0 1.131.22 1.423.729l-.546.318a1.022 1.022 0 0 0-.866-.46c-.48 0-1.053.376-1.053 1.124 0 .73.546 1.131 1.098 1.131.384 0 .702-.215.89-.547l.56.26c-.317.572-.882.877-1.538.877-.826-.001-1.697-.639-1.697-1.71Zm5.187 1.709c.455 0 .884-.202 1.105-.494v.403h.675v-3.256h-.675v.403c-.21-.295-.65-.487-1.105-.487-.994 0-1.69.727-1.69 1.715 0 .968.702 1.716 1.69 1.716Zm.065-2.814c.624 0 1.052.468 1.052 1.098 0 .63-.428 1.098-1.052 1.098-.637 0-1.066-.474-1.066-1.11 0-.624.442-1.086 1.066-1.086Zm5.127.096h-.52v-.65h.526v-.962h.696v.961h.721v.65h-.721v2.626h-.702v-2.625Zm3.348 2.718c.455 0 .884-.202 1.105-.494v.403h.676v-3.256h-.676v.403c-.21-.295-.65-.487-1.105-.487-.994 0-1.69.727-1.69 1.715 0 .968.702 1.716 1.69 1.716Zm.065-2.814c.624 0 1.053.468 1.053 1.098 0 .63-.43 1.098-1.053 1.098-.637 0-1.066-.474-1.066-1.11 0-.624.442-1.086 1.066-1.086Zm-5.426 2.718h-.702v-3.256h.643v.566c.132-.368.414-.618.786-.618a.985.985 0 0 1 .24.026v.63c-.524-.062-.967.305-.967 1.144v1.508Z',
    }),
  );
});
cartaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var carta = {
  category: 'brand',
  colorable: false,
  name: 'carta',
  svg: cartaSvg,
};
